import _defineProperty from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import styled from 'styled-components';
import sx from './sx';
import theme from './theme';
import { COMMON, get } from './constants';
var BranchName = styled.a.withConfig({
  displayName: "BranchName",
  componentId: "sc-1foytcp-0"
})(["display:inline-block;padding:2px 6px;font-size:", ";font-family:", ";color:rgba(27,31,35,0.6);background-color:#eaf5ff;border-radius:3px;", ";", ";"], get('fontSizes.0'), get('fonts.mono'), COMMON, sx);
BranchName.defaultProps = {
  theme: theme
};
BranchName.propTypes = _objectSpread(_objectSpread(_objectSpread({
  href: PropTypes.string
}, COMMON.propTypes), sx.propTypes), {}, {
  theme: PropTypes.object
});
export default BranchName;